import recommendationsFragment from './Fragments/recommendationsFragment'

const getRecommendationSectionsQuery = /* GraphQL */ `
  query GetRecommendationSections(
    $sections: [String]
    $skuBaseNumbers: [String]
    $skuVariantNumbers: [String]
    $articleIds: [String]
    $ymmData: YmmDataInput
    $keywords: String
    $userVin: String
    $webUserGuid: String
  ) {
    recommendationSections(
      sections: $sections
      skuBaseNumbers: $skuBaseNumbers
      skuVariantNumbers: $skuVariantNumbers
      articleIds: $articleIds
      ymmData: $ymmData
      keywords: $keywords
      userVin: $userVin
      webUserGuid: $webUserGuid
    ) {
      ...RecommendationSectionFragment
    }
  }
  ${recommendationsFragment}
`

export default getRecommendationSectionsQuery
